// @flow
import { type ReportFormConfig } from 'state/types';
import localizedStrings from 'util/localizedStrings';

export const reportFormConfigs: ReportFormConfig[] = [
  {
    name: 'asset-uploads',
    label: localizedStrings.ASSET_UPLOADS,
    hasDateRange: true,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_ASSET_UPLOADS,
    viewName: 'assetUploads',
  },
  {
    name: 'asset-most-downloaded',
    label: localizedStrings.ASSET_DOWNLOADS,
    hasDateRange: true,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_DOWNLOADED,
    viewName: 'assetMostDownloaded',
  },
  {
    name: 'asset-most-previewed',
    label: localizedStrings.ASSET_PREVIEWS,
    hasDateRange: true,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_ASSET_PREVIEWS,
    viewName: 'assetMostPreviewed',
  },
  {
    name: 'asset-deletions',
    label: localizedStrings.REPORT_NAME_DELETED_BY,
    hasDateRange: true,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_DELETED_BY,
    viewName: 'deleteBy',
  },
  {
    name: 'asset-downloads',
    label: localizedStrings.REPORT_NAME_DOWNLOADED_BY,
    hasDateRange: true,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_DOWNLOADED_BY,
    viewName: 'downloadBy',
  },
  {
    name: 'file-types',
    label: localizedStrings.FILE_TYPES,
    hasDateRange: false,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_FILE_TYPES,
    viewName: 'fileTypes',
  },
  {
    name: 'search-terms',
    label: localizedStrings.SEARCH_TERMS,
    hasDateRange: true,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_SEARCH_TERMS,
    viewName: 'searchTerms',
  },
  {
    name: 'keyword-statistics',
    label: localizedStrings.KEYWORD_STATISTICS,
    hasDateRange: false,
    organizerType: 'CATALOGS',
    description: localizedStrings.REPORT_DESCRIPTION_KEYWORD,
    viewName: 'keywordStatistics',
  },
  {
    name: 'netpublish-usage',
    label: localizedStrings.NETPUBLISH_USAGE,
    hasDateRange: true,
    organizerType: 'NP_SITES',
    description: localizedStrings.REPORT_DESCRIPTION_USAGE,
    viewName: 'netpublishUsage',
  },
  {
    name: 'netpublish-download-frequency',
    label: localizedStrings.NETPUBLISH_MOST_DOWNLOADED,
    hasDateRange: true,
    organizerType: 'NP_SITES',
    description: localizedStrings.REPORT_DESCRIPTION_DOWNLOADED,
    viewName: 'netpublishDownloadFrequency',
  },
];

export function localeToReportLocale(locale: string) {
  let result = 'en_US';
  switch (locale) {
    case 'fr':
      result = 'fr_FR';
      break;
    case 'de':
      result = 'de_DE';
      break;
    case 'es':
      result = 'es_ES';
      break;
    case 'it':
      result = 'it_IT';
      break;
    case 'ja':
      result = 'ja_JP';
      break;
    default:
      break;
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/util/reportUtils.js